import React from 'react';
import { t } from 'Src/i18n';

type Props = {
  isBundledSchedule: boolean;
  isFullStayBundle: boolean;
  InputComp: () => React.ReactNode;
};

export const ScheduleEnvelopeFSS = ({ isBundledSchedule, isFullStayBundle, InputComp }: Props) => {
  if (isBundledSchedule) {
    const labelKey = isFullStayBundle
      ? 'booking.activities.childcare.chooseWhenFullStay'
      : 'booking.activities.childcare.chooseWhenInnerRange';

    return (
      <div className="flex w-full flex-col pt-20">
        <span className="pb-5 text-14 font-bold text-black">{t(labelKey)}</span>
        <InputComp />
      </div>
    );
  }
  return <InputComp />;
};
